export const TERMS_OF_SERVICE_LINK = 'https://spare.com/terms-of-use'
export const HELP_LINK = 'https://help.sparelabs.com/en/articles/10263309-using-the-driver-backup-interface'